<app-header [showSidebarToggles]="false">
  <app-cashier-periode headerSlot></app-cashier-periode>
</app-header>
<div class="app-body">
  <main class="main cashier-main">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-footer></app-footer>
